import { globalEventBus, EventNames } from '@littlebird/event-bus';

import { getText, toDocumentFrom } from '@/components/ui/editor/utils';
import { migrateLegacyDesktopUserConfig } from '@/stores/user-config-migration';

import { logError } from './errorLogging';
import { littlebirdSdk } from './sdk-init';

/**
 * Initialize bootstrap event listeners for desktop app
 * This runs once at app startup and subscribes to bootstrap events
 */
export function initializeBootstrapListeners() {
  globalEventBus.on(EventNames.BOOTSTRAP_COMPLETE, async () => {
    try {
      await littlebirdSdk.stores.journals.migrateJournals(
        toDocumentFrom,
        getText
      );
    } catch (error) {
      logError(error, '[Bootstrap] Journal migration failed');
    }

    try {
      migrateLegacyDesktopUserConfig();
    } catch (error) {
      logError(error, '[Bootstrap] Legacy user-config migration failed');
    }
  });
}
